var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPropertyInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "propertyIcon",
    d: "M11.1738 13.2051V18.7561C11.1738 19.1013 11.4539 19.3814 11.7991 19.3814H18.2655C18.6107 19.3814 18.8908 19.1013 18.8908 18.7561V13.2051",
    stroke: "#939EAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9633 7.04669C27.3589 11.4423 27.3589 18.5677 22.9633 22.9633C18.5677 27.3589 11.4423 27.3589 7.04669 22.9633C2.6511 18.5677 2.6511 11.4423 7.04669 7.04669C11.4423 2.6511 18.5677 2.6511 22.9633 7.04669",
    stroke: "#939EAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "propertyIcon",
    d: "M9.89844 14.0328L15.1081 10.6289L20.1102 14.0328",
    stroke: "#939EAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyInfo);
export default __webpack_public_path__ + "static/media/propertyInfo.72d109e7.svg";
export { ForwardRef as ReactComponent };